import React from 'react';
import {NavLink} from "react-router-dom";

const BreadCrumbItem = (props) => {
    return (
            <NavLink className={props.BreadcrumbStyle} to={props.Path} ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.6 16"><title>Asset 2</title>
                <g id="Layer_2" data-name="Layer 2">
                    <g id="Layer_1-2" data-name="Layer 1">
                        <path
                            d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                    </g>
                </g>
            </svg><span>{props.Label}</span></NavLink>
    )
};

export default BreadCrumbItem;